import { FilterValues, IFilterValue } from '@src/types/filters.types'

function storageKey(userId: number) {
  return `lastAppliedFeedFilter:${userId}`
}

function isStringArray(value: unknown): value is string[] {
  return Array.isArray(value) && value.every((item) => typeof item === 'string')
}

function isCategoryId(value: unknown) {
  return value === null || value === 'uncategorized' || typeof value === 'number'
}

function isFilterModel(value: unknown): value is IFilterValue {
  const model = value as IFilterValue
  return !!model
    && (model.knowledgeSpaceId === null || typeof model.knowledgeSpaceId === 'number')
    && Array.isArray(model.categoryIds)
    && model.categoryIds.every(isCategoryId)
    && isStringArray(model.filter)
    && isStringArray(model.topics)
    && typeof model.includeArchived === 'boolean'
}

function isUnfiltered(filters: IFilterValue) {
  return !filters.knowledgeSpaceId
    && filters.categoryIds.length === 0
    && filters.topics.length === 0
    && !filters.includeArchived
    && filters.filter.every((value) => value === FilterValues.All)
}

export function getLastAppliedFeedFilter(userId: number): IFilterValue | null {
  try {
    const stored = localStorage.getItem(storageKey(userId))
    const parsed = stored ? JSON.parse(stored) : null
    return isFilterModel(parsed) && !isUnfiltered(parsed) ? parsed : null
  } catch {
    return null
  }
}

export function clearLastAppliedFeedFilter(userId: number) {
  try {
    localStorage.removeItem(storageKey(userId))
  } catch {
    // storage unavailable (private mode / blocked): feature degrades to current behaviour
  }
}

export function setLastAppliedFeedFilter(userId: number, filters: IFilterValue) {
  if (isUnfiltered(filters)) {
    clearLastAppliedFeedFilter(userId)
    return
  }
  try {
    localStorage.setItem(storageKey(userId), JSON.stringify(filters))
  } catch {
    // see clearLastAppliedFeedFilter
  }
}
